<template>
  <div
    :class="[type === 'balance' ? 'wallet' : 'referral-wallet']"
    class="h-[150px] sm:h-auto p-3 sm:p-5 border w-full flex justify-between rounded-xl relative !overflow-hidden"
  >
    <div class="flex flex-col items-start justify-between relative z-10">
      <p class="text-sm font-normal text-white rounded-xl">
        {{ type === "balance" ? $t("balans_wallet") : $t("referral_balance") }}
      </p>
      <div class="flex items-end mt-6 gap-1">
        <p class="text-3xl sm:text-4.5xl font-bold text-white leading-normal">
          {{ type === "balance" ? user?.balance : user?.referral_balance }}
        </p>
        <span
          class="text-white/60 text-sm sm:text-base font-medium leading-normal -translate-y-1.5 uppercase"
        >
          {{ $t("usd") }}
        </span>
      </div>
    </div>
    <div class="flex flex-col items-end justify-between gap-3 z-100">
      <template v-if="type === 'balance'">
        <CButton
          icon="icon-add-circle text-xl leading-5"
          icon-position="left"
          :text="$t('fill')"
          size="sm"
          class="w-full"
          @click="handleShowApplication"
        />
      </template>
      <template v-if="type === 'referral'">
        <button>
          <CCopy
            :title="$t('referral_link')"
            :text="userReferralNumber"
            button-class="flex-y-center gap-1"
            title-class="text-left"
            tooltip-class="!left-[-60px] !top-[-3px]"
          />
        </button>
        <CButton
          icon="icon-wallet text-xl leading-5 "
          icon-position="left"
          :text="$t('transfer_amount')"
          size="sm"
          class="w-max"
          @click="handleShowTransfer"
        />
      </template>
    </div>
    <div :class="[type === 'balance' ? 'round' : 'round-wallet']" />
    <img
      class="absolute bottom-0 left-1/2 -translate-x-1/2 z-0"
      src="/images/svg/wallet-pattern.svg"
      alt="wallet pattern"
    />
  </div>
</template>

<script setup lang="ts">
import CButton from "@/components/Common/CButton.vue";
import { computed } from "vue";
import { useAuthStore } from "@/modules/Auth/stores";
import CCopy from "@/components/Common/CCopy.vue";
interface Props {
  type: "balance" | "referral";
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "handleShowTransfer"): void;
  (e: "handleShowApplication"): void;
}>();
const user = computed(() => useAuthStore()?.user);

const userReferralNumber = computed(
  () =>
    `https://app.sarafrobot.com/auth/register?referral_number=${user.value.referral_number}`,
);

const handleShowTransfer = () => {
  emit("handleShowTransfer");
};
const handleShowApplication = () => {
  emit("handleShowApplication");
};
</script>

<style scoped>
.wallet {
  box-shadow: 0px 0px 30px 0px rgba(56, 71, 109, 0.09);
  background: linear-gradient(180deg, #000 -9.68%, #10632b 88.33%);
}
.referral-wallet {
  box-shadow: 0px 0px 30px 0px rgba(56, 71, 109, 0.09);
  background: linear-gradient(180deg, #000 -9.68%, #356bbf 88.33%);
}
.round {
  width: 300px;
  height: 300px;
  filter: blur(250px);
  background: #16cc53;
  border-radius: 300px;
  position: absolute;
  left: 54px;
  top: 100px;
  z-index: 0;
}
.round-wallet {
  width: 300px;
  height: 300px;
  filter: blur(250px);
  background: #4489f7;
  border-radius: 300px;
  position: absolute;
  left: 54px;
  top: 100px;
  z-index: 0;
}
</style>
